import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'priceFormat'
})
export class PriceFormatPipe implements PipeTransform {

  transform(value: number | string, currency: string = ''): string {
    if (value === null || value === undefined) return '';
    
    // Ensure value is a number
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    
    // Format with comma for thousands and dot for decimal
    const formattedNumber = numericValue.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });

    return currency ? `${formattedNumber} ${currency}` : formattedNumber;
  }

}
